import { render, staticRenderFns } from "./TrustDocVerifyInitiate.vue?vue&type=template&id=6e45b19c&scoped=true"
import script from "./TrustDocVerifyInitiate.vue?vue&type=script&lang=js"
export * from "./TrustDocVerifyInitiate.vue?vue&type=script&lang=js"
import style0 from "./TrustDocVerifyInitiate.vue?vue&type=style&index=0&id=6e45b19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45b19c",
  null
  
)

export default component.exports